<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="图片描述">
                  <el-input  v-model="queryForm.picDesc"></el-input>
              </el-form-item>
              <el-form-item label="相册类型：图片、视频">
                  <el-input  v-model="queryForm.albumType"></el-input>
              </el-form-item>
              <el-form-item label="相册图片、视频首帧图">
                  <el-input  v-model="queryForm.albumPic"></el-input>
              </el-form-item>
              <el-form-item label="视频地址">
                  <el-input  v-model="queryForm.albumVideo"></el-input>
              </el-form-item>
              <el-form-item label="相册标签">
                  <el-input  v-model="queryForm.albumTag"></el-input>
              </el-form-item>
              <el-form-item label="所属门店">
                  <el-input  v-model="queryForm.storeId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreAlbumList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopStoreAlbum"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopStoreAlbum(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStoreAlbum(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopStoreAlbumList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStoreAlbumList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="albumPic"
            label="相册图片/视频首帧图"
            width="180"
        >
            <template slot-scope="scop">
                <el-image
                    @click='updateSrcList(scop.row.albumPic)'
                    style="width: 30px; height: 30px"
                    :src="scop.row.albumPic"
                    :preview-src-list="srcList"
                ></el-image>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="picDesc"
        label="图片描述"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="albumType"
        label="相册类型"
        width="180"
      >
          <template slot-scope="scope">
            {{ scope.row.albumType == 1 ? "图片" : "视频" }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="albumVideo"
        label="视频地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="albumTag"
        label="相册标签"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="storeId"-->
<!--        label="所属门店"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStoreAlbum(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopStoreAlbum(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopStoreAlbum(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStoreAlbumStates[shopStoreAlbumState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="shopStoreAlbum"
          ref="shopStoreAlbumForm"
          :rules="rules"
          label-width="90px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="相册类型"
            prop="albumType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStoreAlbum.albumType"-->
<!--              :disabled="shopStoreAlbumState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                style="width: 177px"
                v-model="shopStoreAlbum.albumType"
                :disabled="shopStoreAlbumState == 'check'"
              >
                <el-option
                  label="图片"
                  :value="1"
                >
                </el-option>
                  <el-option
                      label="视频"
                      :value="2"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="视频地址"-->
<!--            prop="albumVideo"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="shopStoreAlbum.albumVideo"-->
<!--              :disabled="shopStoreAlbumState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="相册标签"
            prop="albumTag"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="shopStoreAlbum.albumTag"
              :disabled="shopStoreAlbumState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="所属门店"-->
<!--            prop="storeId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="shopStoreAlbum.storeId"-->
<!--              :disabled="shopStoreAlbumState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
            <el-form-item
                label="图片/视频"
                prop="albumPic"
                v-if="shopStoreAlbum.albumType"
            >
                <el-upload
                    action=""
                    :disabled="shopStoreAlbumState == 'check'"
                    class="avatar-uploader"
                    :show-file-list="false"
                    :http-request="uploadAvatar"
                    style="width: 177px"
                >
                    <img
                        v-if="shopStoreAlbum.albumPic"
                        :src="shopStoreAlbum.albumPic"
                        class="avatar"
                    />
                    <i
                        v-else
                        class="el-icon-plus avatar-uploader-icon"
                    ></i>
                </el-upload>
            </el-form-item>
            <el-form-item
                label="图片描述"
                prop="picDesc"
            >
                <el-input
                    size="small"
                    type="textarea"
                    :rows="4"
                    style="width: 177px"
                    v-model="shopStoreAlbum.picDesc"
                    :disabled="shopStoreAlbumState == 'check'"
                ></el-input>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStoreAlbumState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStoreAlbumList();
                    this.getShopStoreAlbumList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStoreAlbumList();
                    this.getShopStoreAlbumList();
                    this.$emit('resetCheckState');
                }
            },
            "shopStoreAlbum.albumType":{
                handler(val) {
                    if(val){
                        this.shopStoreAlbum.albumPic = "";
                        this.shopStoreAlbum.albumVideo = "";
                    }
                }
            }
        },
    data() {
            return {
                queryForm:{
                     picDesc: '', //图片描述
                     albumType: '', //相册类型：图片、视频
                     albumPic: '', //相册图片、视频首帧图
                     albumVideo: '', //视频地址
                     albumTag: '', //相册标签
                     storeId: '', //所属门店
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStoreAlbumState: 'add',
                shopStoreAlbumStates: {
                    add: '新建相片',
                    check: '查看相片',
                    edit: '修改相片'
                },
                srcList: [''],

                multipleSelection: [],
                shopStoreAlbumList: [],
                shopStoreAlbum: {
                    id: '', //
                    picDesc: '', //图片描述
                    albumType: '', //相册类型：图片、视频
                    albumPic: '', //相册图片、视频首帧图
                    albumVideo: '', //视频地址
                    albumTag: '', //相册标签
                    storeId: '', //所属门店
                },
                btnLoading: false,

                rules: {
                    picDesc: [{ required: true, message: '图片描述不能为空', trigger: 'blur' }],
                    albumType: [{ required: true, message: '相册类型：图片、视频不能为空', trigger: 'blur' }],
                    albumPic: [{ required: true, message: '相册图片、视频首帧图不能为空', trigger: 'blur' }],
                    albumVideo: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
                    albumTag: [{ required: true, message: '相册标签不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '所属门店不能为空', trigger: 'blur' }],
                }
            };
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                // let types = ['image/jpeg', 'image/png', 'image/jpg'];
                // if (!types.includes(file.type)) {
                //     this.$message({
                //         message: '只能上传图片格式的文件，png.jpg或者jpeg',
                //         type: 'error',
                //         showClose: true,
                //         duration: 2000
                //     });
                //     return;
                // }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                let url = this.shopStoreAlbum.albumType == 1 ? '/mpp/image/upload' : '/mpp/file/upload'
                upload(url, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.shopStoreAlbum.albumPic = this.shopStoreAlbum.albumType == 1 ? res.url :res.videoCover;
                        this.shopStoreAlbum.albumVideo = this.shopStoreAlbum.albumType == 1 ? '' : res.url;
                    }else{
                        this.$message.error(res.msg)
                    }
                });
            },
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            init(id){
                this.resetShopStoreAlbumList();
                this.queryForm.storeId = id;
                this.shopStoreAlbum.storeId = id;
                this.getShopStoreAlbumList();
            },
            resetShopStoreAlbumList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStoreAlbumList = [];
            },
            resetDialog() {
                this.shopStoreAlbumState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      picDesc: '', //图片描述
                      albumType: '', //相册类型：图片、视频
                      albumPic: '', //相册图片、视频首帧图
                      albumVideo: '', //视频地址
                      albumTag: '', //相册标签
                      storeId: this.queryForm.storeId, //所属门店
                };
                this.getShopStoreAlbumList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopStoreAlbum = {
                      id: '', //
                      picDesc: '', //图片描述
                      albumType: '', //相册类型：图片、视频
                      albumPic: '', //相册图片、视频首帧图
                      albumVideo: '', //视频地址
                      albumTag: '', //相册标签
                      storeId: this.shopStoreAlbum.storeId, //所属门店
                };
            },
            submitForm() {
                if (this.shopStoreAlbumState == 'add') {
                    this.$refs.shopStoreAlbumForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storealbum/add`,{ ...this.shopStoreAlbum }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStoreAlbumList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStoreAlbumState == 'edit') {
                    this.$refs.shopStoreAlbumForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storealbum/edit`,{ ...this.shopStoreAlbum }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStoreAlbumList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopStoreAlbum() {
                this.showDialog = true;
                this.shopStoreAlbumState = 'add';
            },
            checkShopStoreAlbum(shopStoreAlbumId) {
                console.log(shopStoreAlbumId);
                this.currentShopStoreAlbumId = shopStoreAlbumId;

                this.getShopStoreAlbumById();
                this.showDialog = true;
                this.shopStoreAlbumState = 'check';
            },
            editShopStoreAlbum(shopStoreAlbumId) {
                console.log('shopStoreAlbum', shopStoreAlbumId);
                if (shopStoreAlbumId) {
                    this.currentShopStoreAlbumId = shopStoreAlbumId;
                    this.getShopStoreAlbumById();
                } else {
                    this.shopStoreAlbum = { ...this.shopStoreAlbum, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStoreAlbumState = 'edit';
            },
            deleteShopStoreAlbum(shopStoreAlbumId) {
                let ids = '';
                if (shopStoreAlbumId) {
                    ids = shopStoreAlbumId;
                } else {
                    ids = this.multipleSelection.map((shopStoreAlbum) => shopStoreAlbum.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storealbum/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreAlbumList();
                                this.getShopStoreAlbumList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStoreAlbumList() {
                this.resetShopStoreAlbumList();
                this.getShopStoreAlbumList();
            },
            getShopStoreAlbumList(query = {}) {
                this.loading = true;
                get(`/shop/storealbum/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStoreAlbumList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStoreAlbumById() {
                get(`/shop/storealbum/get`,{ id: this.currentShopStoreAlbumId }).then((res) =>{
                    if(res.success){
                      this.shopStoreAlbum = { ...this.shopStoreAlbum, ...res.shopStoreAlbum };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStoreAlbumList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/storealbum/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storealbum/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storealbum/importData`,formData);
              this.refreshShopStoreAlbumList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStoreAlbumList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStoreAlbumList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}

::v-deep .el-upload--text {
    width: 177px;
    height: 177px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator{
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 180px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    &>div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>